export default __webpack_public_path__ + "static/media/image2.a3ce2659.png";